import React from 'react'
import { MDBIcon } from "mdbreact"
import { useHistory } from "react-router-dom"
import {Icon} from "@iconify/react"
import babyBottle from '@iconify-icons/mdi/baby-bottle'
import "./nav.css";
import { Navbar, Nav } from "react-bootstrap";
import salineDrip from "@iconify-icons/openmoji/saline-drip";
import lineGraph from "@iconify-icons/gridicons/line-graph";
import openBook from "@iconify-icons/emojione-monotone/open-book";

function Navb() {

    let history = useHistory();

    const home = () => {
        history.push("/");
        localStorage.clear();
    }
    const growth = () => {

        history.push("/growth");  
    }

    const total = () => {
        history.push("/total")
    }

    const enteral = () => {
        history.push("/enteral")
    }

    const references = () => {
        history.push("/references")
    }


    return (
    <div className = "row">
      <div className = "col-md-12">
    <div className = "navbar__setting">
    <div className="header">
    <div className="header__nav">


        <div className="header__option">
          <span className="header__optionLineOne"><MDBIcon className = "home__class" onClick={home}  href = "/" icon="home" size = "3x"/></span>
        </div>

        <div className="header__option">
          <span className="header__optionLineOne">
            <Icon icon={lineGraph} className="growth__class" onClick={growth} href = "growth" />
            </span>
        </div>
      
        <div className="header__option">
          <span className="header__optionLineOne">
            <Icon className = "tpn__class" icon={salineDrip} onClick={total} size = "3x" /></span>
        </div>
      
      <div className="header__option">
        <span className="header__optionLineOne"><Icon onClick={enteral} href ="/enteral" icon ={babyBottle} className="baby__bottle"/></span>
      </div>


        <div className="header__option">
          <span className="header__optionLineOne">
            <Icon icon={openBook} className="ref__class" onClick={references} href = "/references" />
            </span>
        </div>
        </div>
        </div>
        </div>
        </div>
      </div>
        

        
    )
}

export default Navb
